import PropTypes from 'prop-types';
import ReloadHelper from '../../utils/ReloadHelper';
import UrlHelper from '../../utils/UrlHelper';
import SwitchButton from './SwitchButton';
import { Component } from 'react';

class PremiumOnlySwitch extends Component {
	static getLink(isActive) {
		const newParams = UrlHelper.getParams(window.location.search);

		if (isActive) {
			newParams.premiumOnly = isActive;
		} else {
			delete newParams.premiumOnly;
		}

		delete newParams.page;

		if (!isActive && Object.keys(newParams).length === 0 && newParams.constructor === Object) {
			return window.location.pathname;
		}

		const newLink =
			window.location.pathname +
			'?' +
			Object.keys(newParams)
				.map((param, index) => (index > 0 ? '&' : '') + param + '=' + newParams[param])
				.join('');

		return newLink;
	}

	constructor(props) {
		super(props);
		this.state = {
			isActive: this.props.isActive,
		};

		this.doSwitch = this.doSwitch.bind(this);
	}

	doSwitch() {
		const newlink = PremiumOnlySwitch.getLink(!this.state.isActive);
		if (newlink) {
			ReloadHelper.reload(newlink);
		}
		this.setState({
			isActive: !this.state.isActive,
		});
	}

	render() {
		return (
			<div className={'switch-button__wrapper' + (this.props.isMobile ? ' switch-button__wrapper--mobile' : '')}>
				<span className={'switch-button__title' + (this.props.isMobile ? ' switch-button__title--mobile' : '')}>
					Nur Premium Inhalte anzeigen:
				</span>
				<SwitchButton isActive={this.state.isActive} doSwitch={this.doSwitch} text={'Premium Inhalte'} />
			</div>
		);
	}
}

PremiumOnlySwitch.propTypes = {
	isActive: PropTypes.bool,
	isMobile: PropTypes.bool,
};

PremiumOnlySwitch.defaultProps = {
	isMobile: false,
};

export default PremiumOnlySwitch;
